namespace SolovisGateway.Admin.DbServers {

    /**
     * ChangeDatabaseServiceTierDialog presents the user interface for changing database service tiers.
     */
    export class ChangeDatabaseServiceTierDialog {

        private _server: string;
        private _databaseName: string;
        private _initialElasticPool;
        private _initialServiceTier;
        private _changeRequestedCallback;

        private _formBuilder: Solovis.UI.InputControls.FormBuilder;
        private _dialog: Solovis.UI.Dialog;

        private _dbServerInfo;

        private _dbServerToElasticPoolNamesMap;

        constructor(options) {
            this._server = options.server;
            this._databaseName = options.databaseName;
            this._initialElasticPool = options.initialElasticPool;
            this._initialServiceTier = options.initialServiceTier;
            this._changeRequestedCallback = options.changeRequestedCallback;

            this._dbServerToElasticPoolNamesMap = [];
        }

        public show() {
            let self = this;
            
            Solovis.Rpc.invokeAndWait(
                "~/Rpc/DbServers/GetDbServers",
                {},
                function (response, success) {
                    if (success) {
                        self._dbServerInfo = _.find(response.result.dbServers, function (i: any) {
                            return i.server == self._server;
                        });

                        if (!self._dbServerInfo) {
                            Solovis.UI.alert("Database server not found.");
                        }
                        else if (!self._dbServerInfo.isSqlAzure) {
                            Solovis.UI.alert("Database server is not SQL Azure.");
                        }
                        else {
                            self._internalShow();
                        }
                    }
                });            
        }

        public _internalShow() {

            let formBuilderDiv = $("<div>");
            let formBuilder = new Solovis.UI.InputControls.FormBuilder({
                container: formBuilderDiv
            });
            this._formBuilder = formBuilder;

            // Elastic Pool
            formBuilder.addEntry({
                name: "elasticPoolName",
                label: "Elastic Pool",

                initialValue: this._initialElasticPool,

                editor: {
                    type: "select",
                    selectOptions: {
                        dataSource: this._createElasticPoolDataSource(),
                        showClearButton: true,
                        searchEnabled: true
                    }
                }
            });

            // Service Tier
            formBuilder.addEntry({
                name: "serviceTier",
                label: "Service Tier",

                initialValue: this._initialServiceTier,

                editor: {
                    type: "select",
                    selectOptions: {
                        data: [
                            { text: "S0", value: "S0" },
                            { text: "S1", value: "S1" },
                            { text: "S2", value: "S2" },
                            { text: "S3", value: "S3" },
                            { text: "S4", value: "S4" },
                            { text: "S6", value: "S6" },
                            { text: "S7", value: "S7" },
                            { text: "S9", value: "S9" },
                            { text: "S12", value: "S12" },
                            { text: "P1", value: "P1" },
                            { text: "P2", value: "P2" },
                            { text: "P4", value: "P4" },
                            { text: "P6", value: "P6" },
                            { text: "P11", value: "P11" },
                            { text: "P15", value: "P15" },
                            { text: "PRS1", value: "PRS1" },
                            { text: "PRS2", value: "PRS2" },
                            { text: "PRS4", value: "PRS4" },
                            { text: "PRS6", value: "PRS6" },
                        ],
                        showClearButton: true
                    }
                },

                isVisible: function (formEntry) {                   
                    let elasticPoolName = formEntry.formBuilder.getValueByName("elasticPoolName");

                    return !elasticPoolName;
                }
            });

            formBuilder.setupDone();

            this._dialog = formBuilder.showAsDialog({
                title: "Change Database Service Tier",
                desiredWidth: 700,
                desiredHeight: 400,
                modal: true,

                showSaveCancel: true,                
                saveCallback: () => {
                    this._save();
                    return false;
                },
                saveButtonText: "Request Change"
            });
        }

        private _createElasticPoolDataSource() {
            let self = this;

            let elasticPoolDataSource: Solovis.UI.InputControls.FormEditorSimpleDataSource = {
                load: function (loadOptions) {
                    let promise = new Promise(function (resolve, reject) {
                        let dbServer = self._server;

                        let doLookup = function () {
                            let elasticPoolNames: string[] = self._dbServerToElasticPoolNamesMap[dbServer];

                            let results = [];

                            if (!_.isEmpty(elasticPoolNames)) {
                                for (let poolName of elasticPoolNames) {
                                    if (!loadOptions.searchValue || poolName.indexOf(loadOptions.searchValue) >= 0) {
                                        results.push({ text: poolName, value: poolName });
                                    }
                                }
                            }

                            resolve(results);
                        };

                        if (self._dbServerToElasticPoolNamesMap[dbServer]) {
                            doLookup();
                        }
                        else {
                            Solovis.Rpc.invoke(
                                "~/Rpc/DbServers/GetElasticPoolsForDbServer",
                                { server: dbServer },
                                function (response, success) {
                                    if (success) {
                                        let elasticPoolNames: string[] = response.result.elasticPoolNames;
                                        self._dbServerToElasticPoolNamesMap[dbServer] = elasticPoolNames;

                                        doLookup();
                                    }
                                    else {
                                        reject(response);
                                    }
                                });
                        }
                    });

                    return promise;
                },

                byKey: function (key) {
                    let promise = new Promise(function (resolve, reject) {
                        resolve({ text: key, value: key });
                    });

                    return promise;
                }
            };

            return elasticPoolDataSource;
        }

        public _save() {
            let self = this;

            let elasticPoolName = this._formBuilder.getValueByName("elasticPoolName");
            let serviceTier = this._formBuilder.getValueByName("serviceTier");

            Solovis.Rpc.invokeAndWait(
                "~/Rpc/DbServers/ChangeDatabaseServiceTier",
                {
                    server: this._server,
                    databaseName: this._databaseName,
                    elasticPoolName: elasticPoolName,
                    serviceTier: !elasticPoolName ? serviceTier : null
                },
                function (response, success) {
                    if (success) {
                        self._dialog.close();

                        Solovis.UI.alert("Service tier change requested. It may take a while to complete.");

                        if (self._changeRequestedCallback) {
                            self._changeRequestedCallback();
                        }
                    }
                });
        }
    }


}